module.exports = __webpack_public_path__ + "img/hx_b.571e8191.png";